import { render, staticRenderFns } from "./ReferralReactorProduct.vue?vue&type=template&id=5e534f14&"
import script from "./ReferralReactorProduct.vue?vue&type=script&lang=ts&"
export * from "./ReferralReactorProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports